export default __webpack_public_path__ + "static/media/background.0f111f2e.jpg";